import {OralFeaturedMedData} from "@/design-system/Organisms/OralMedFeaturedMedSection/featuredMed.data"; 

export const oralMedFeaturedMedicineConfig = {   
    heading: "Defy Benefits",
    highlightedHeadingMain: "Featured",
    highlightedHeadingAccent: "Oral ED Medications",
    describe:"The ED medications you want, when you want them.",
    medList: OralFeaturedMedData,
};